import { toPackageName } from '@atlassian/jira-project-settings-apps-common/src/consts.tsx';

export const APP_ID = 'project-settings/connect-apps';
export const PACKAGE_NAME = toPackageName('jiraProjectSettingsAppsConnectApps');
